import React, { useEffect, useState, useRef } from 'react';
import { useInView } from 'framer-motion';
interface CountUpProps {
  end: number;
  duration?: number;
  suffix?: string;
}
export function CountUp({
  end,
  duration = 2,
  suffix = ''
}: CountUpProps) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (isInView) {
      let startTime: number;
      let animationFrame: number;
      const animate = (timestamp: number) => {
        if (!startTime) startTime = timestamp;
        const progress = timestamp - startTime;
        const percentage = Math.min(progress / (duration * 1000), 1);
        // Easing function (easeOutExpo)
        const easeProgress = percentage === 1 ? 1 : 1 - Math.pow(2, -10 * percentage);
        setCount(Math.floor(easeProgress * end));
        if (percentage < 1) {
          animationFrame = requestAnimationFrame(animate);
        }
      };
      animationFrame = requestAnimationFrame(animate);
      return () => cancelAnimationFrame(animationFrame);
    }
  }, [end, duration, isInView]);
  return <span ref={ref} data-id="element-31">
      {count}
      {suffix}
    </span>;
}